/**
 * Respawn13 — Hero carousel
 *   - Native scroll-snap for swipe / arrow / dot navigation
 *   - IntersectionObserver tracks the active slide
 *   - Autoplay (paused on hover/focus + when reduced-motion is preferred)
 *   - Loops on prev/next
 */
(function () {
  'use strict';

  function initHero(root) {
    var viewport = root.querySelector('[data-hero-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    if (!viewport || slides.length < 2) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySeconds = parseInt(root.getAttribute('data-autoplay-seconds'), 10) || 5;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function scrollTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      var slide = slides[index];
      // Use scroll-snap behavior via scrollTo
      viewport.scrollTo({
        left: slide.offsetLeft - viewport.offsetLeft,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    /* Track active slide via IntersectionObserver */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            var idx = slides.indexOf(entry.target);
            if (idx !== -1 && idx !== current) {
              current = idx;
              updateDots();
            }
          }
        });
      }, { root: viewport, threshold: [0.5] });
      slides.forEach(function (s) { io.observe(s); });
    }

    /* Wire arrows */
    if (prev) prev.addEventListener('click', function () { stop(); scrollTo(current - 1); });
    if (next) next.addEventListener('click', function () { stop(); scrollTo(current + 1); });

    /* Wire dots */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        scrollTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
      });
    });

    /* Keyboard nav */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stop(); scrollTo(current - 1); }
      if (e.key === 'ArrowRight') { stop(); scrollTo(current + 1); }
    });

    /* Autoplay */
    function start() {
      if (!autoplay || prefersReducedMotion) return;
      stop();
      timer = setInterval(function () { scrollTo(current + 1); }, autoplaySeconds * 1000);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    /* Pause when tab not visible */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    start();
  }

  function bootAll() {
    document.querySelectorAll('[data-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      var hero = e.target.querySelector('[data-hero]');
      if (hero) initHero(hero);
    }
  });
})();
